import React from 'react';

import BrockLogo from './images/BrockSolutions.svg';
import { Link } from 'react-router-dom';
import { HorizontalFlex, PadContainer } from 'smartsuite-ui';

function Footer() {
    return (
        <HorizontalFlex>
            <div className="footer__logo-container">
                <img
                    src={BrockLogo}
                    alt="BrockSolutions"
                    className="footer__logo"
                />
                <Link
                    to="/documents"
                    target="_blank"
                    className="footer__sneaky-link"
                />
            </div>
            <PadContainer>|</PadContainer>
            <span>© 2003-2025 Brock Solutions Inc.</span>
        </HorizontalFlex>
    );
}
export default Footer;
